module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chap-img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/img6.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "chap"
  }, [_c('a', {
    attrs: {
      "id": "ch2"
    }
  }), _vm._v("TRANSATLANTIC COD BRIDGE, 1492")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("I")]), _vm._v("n the decades before Columbus’s voyage in 1492, Basque fishermen, from the northern part of Spain, may have beaten him to the New World. Author Mark Kurlansky presents strong evidence that the Genoese sailor was perhaps a “Christopher-come-lately.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Near the Pyrenees Mountains between Spain and France lies Basque Country, inhabited by a hearty people, jealous of their independence. In the Middle Ages, Basque fishermen supplied Catholics with salted cod for holy days. What was their special source of cod? When Germans monopolized Icelandic cod and cut off English supplies in 1475, Basque fishermen quickly stepped in with a steady supply of superb-quality dried and salted cod.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Evidence is strong that the tight-lipped Basques had discovered the desolate shores of Newfoundland, Nova Scotia, and perhaps even New England and the Grand Banks offshore, teeming with cod. The Basques never challenged Columbus’s claims. Perhaps they knew how to keep a trade secret. "), _c('span', {
    staticClass: "color"
  }, [_vm._v("(12-012)")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/img7.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a99baa3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter002.vue
// module id = 81
// module chunks = 0